import { timerHelperModule } from '../../../../shared/app/helpers/timer-helper';
import * as EventUtils from '../../../../shared/app/utils/event-utils';

const SECOND = 1000;
const WARNING_TIME = 5 * 60;

export const assessmentTimerServiceModule = angular
  .module('Q.services.assessment-timer-service', [timerHelperModule])

  .factory('assessmentTimerService', function (timerHelper, $rootScope) {
    class Timer {
      constructor(isCountUp) {
        this.intervalPromise = null;
        this.isCountUp = !!isCountUp;
        this.isCountDown = !isCountUp;

        EventUtils.eventEmitter(this);
      }

      stop() {
        const self = this;
        self.fire('tick');
        if (self.intervalPromise) {
          self.intervalPromise.stop();
          self.intervalPromise = null;
          self.fire('stop');
        }
        self.stopTime = Date.now();
      }

      reset() {
        this.startTime = null;
        this.time = 0;
        this.stop();
        this.stopTime = null;
      }

      fire(event) {
        this.emit(event, this.time);
      }

      timeElapsed() {
        if (this.startTime) {
          let endTime =
            !this.isRunning() && this.stopTime ? this.stopTime : Date.now();
          return Math.floor((endTime - this.startTime) / SECOND);
        } else {
          return 0;
        }
      }

      isRunning() {
        return !!this.intervalPromise;
      }

      getTime() {
        return this.time;
      }
    }

    class CountUpTimer extends Timer {
      constructor(timeExpected) {
        super(true);
        this.timeExpected = timeExpected;
      }

      start({ wallTimeSinceStart } = {}) {
        const self = this;
        if (self.isRunning()) return;

        self.startTime = Date.now();
        if (wallTimeSinceStart) self.startTime -= wallTimeSinceStart * 1000;
        self.time = self.timeElapsed();
        self.intervalPromise = timerHelper.runEvery(
          () => {
            self.time = self.timeElapsed();
            self.fire('tick');
          },
          SECOND / 2,
          false,
        );
        self.fire('start');
      }

      progress() {
        const totalProgress = (this.timeElapsed() / this.timeExpected) * 100;
        return Math.max(0, Math.min(100, totalProgress || 0));
      }
    }

    class CountDownTimer extends Timer {
      constructor(timeAllotted) {
        super(false);
        this.timeAllotted = timeAllotted;
        this.time = this.timeAllotted;
        this.warned = false;
        this.fire('tick');
      }

      reset() {
        super.reset();
        this.time = this.timeAllotted;
        this.warned = false;
      }

      start({ wallTimeSinceStart, timerExpiresIn } = {}) {
        const self = this;
        if (self.isRunning()) return;

        self.startTime = Date.now();
        if (wallTimeSinceStart) self.startTime -= wallTimeSinceStart * 1000;
        self.time = timerExpiresIn;
        self.fire('tick');

        if (self.time <= 0) {
          self.time = 0;
          self.fire('done');
        } else {
          self.intervalPromise = timerHelper.runEvery(
            () => {
              self.time = self.timeAllotted - self.timeElapsed();
              self.fire('tick');
              if (self.time <= 0) {
                self.warned = true;
                self.time = 0;
                self.stop();
                $rootScope.$applyAsync(() => self.fire('done'));
              } else if (self.time <= WARNING_TIME && !self.warned) {
                self.warned = true;
                $rootScope.$applyAsync(() => self.fire('warning'));
              }
            },
            SECOND / 2,
            false,
          );

          self.fire('start');
        }
      }

      progress() {
        const totalProgress = (this.timeElapsed() / this.timeAllotted) * 100;
        return Math.max(0, Math.min(100, totalProgress || 0));
      }
    }

    return { CountDownTimer, CountUpTimer };
  });
